import React from 'react';

// Plain-language labels + badge tone for every backend status. The raw status
// stays available as the badge's title for support/debugging.

export const BATCH_STATUS = {
    DRAFT: ['Draft', 'gray'],
    VALIDATING: ['Checking…', 'blue'],
    READY: ['Ready', 'blue'],
    READY_WITH_WARNINGS: ['Ready · warnings', 'amber'],
    INVALID: ['Invalid', 'red'],
    QUEUED: ['Queued', 'blue'],
    RUNNING: ['Running', 'blue'],
    COMPLETED: ['Completed', 'green'],
    COMPLETED_WITH_ERRORS: ['Completed with errors', 'orange'],
    CANCELLED: ['Cancelled', 'gray'],
};

export const SERIES_STATUS = {
    DISCOVERED: ['Found', 'gray'],
    READY: ['Ready', 'blue'],
    VALIDATION_FAILED: ["Can't import", 'red'],
    QUEUED: ['Queued', 'blue'],
    SUBMITTING: ['Submitting', 'blue'],
    PROCESSING: ['Transcoding', 'blue'],
    COMPLETE: ['Complete', 'green'],
    COMPLETED_WITH_ERRORS: ['Completed with errors', 'orange'],
    FAILED: ['Failed', 'red'],
    ROW_UPDATE_FAILED: ['Failed', 'red'],
    CANCELLED: ['Cancelled', 'gray'],
};

export const EPISODE_STATUS = {
    DISCOVERED: ['Pending', 'gray'],
    QUEUED: ['Queued', 'blue'],
    SUBMITTING: ['Submitting', 'blue'],
    PROCESSING: ['Transcoding', 'blue'],
    COMPLETE: ['Complete', 'green'],
    FAILED: ['Failed', 'red'],
    IGNORED_EXISTING_PATH: ['Already imported', 'gray'],
    CANCELLED: ['Cancelled', 'gray'],
};

// What start will do to a not-yet-started episode (set by the validate preview).
export const DECISION = {
    new: ['New', 'blue'],
    ignored_existing_path: ['Already imported · skip', 'gray'],
    retranscode: ['Replaces existing', 'amber'],
};

// Short tag shown before each preview warning.
export const ISSUE_TAG = {
    TRAILER_MISSING: 'Trailer',
    MISSING_EPISODE_NUMBERS: 'Gap',
    ALREADY_IMPORTED: 'Skipped',
    REPLACES_EXISTING_EPISODES: 'Replaces',
    NON_MP4_FILES_IGNORED: 'Ignored',
    INVALID_EPISODE_NUMBER: "Can't import",
    DUPLICATE_EPISODE_NUMBER: "Can't import",
    NOT_SELECTED: 'Not selected',
};

export const NOT_STARTED_BATCH_STATUSES = ['DRAFT', 'VALIDATING', 'READY', 'READY_WITH_WARNINGS', 'INVALID'];
export const CANCELLABLE_BATCH_STATUSES = ['DRAFT', 'VALIDATING', 'READY', 'READY_WITH_WARNINGS', 'INVALID', 'QUEUED', 'RUNNING'];

export const StatusBadge = ({ map, status, children }) => {
    const [label, tone] = map[status] || [status || '—', 'gray'];
    return (
        <span className={`bsi-badge ${tone}`} title={status}>
            {children}{label}
        </span>
    );
};
